module.exports = __webpack_public_path__ + "img/ID_CO2_Fair_Icon.fc2ed02a.svg";